import _get from 'lodash/get';
import store from '@/store';

const getUserFeatures = () => _get(store, 'state.user.user.features') || {};

export default getUserFeatures;
